import { EActions, ESubjects } from "@/api/models/auth/ability";
import { useAbility } from "@casl/vue";
import { computed } from "vue";

export const useInvitePermissions = () => {
  const { can } = useAbility();

  const canCreateInvite = computed(() => can(EActions.CREATE, ESubjects.INVITE__INVITE));
  const canReadInvite = computed(() => can(EActions.READ, ESubjects.INVITE__INVITE));
  const canUpdateInvite = computed(() => can(EActions.UPDATE, ESubjects.INVITE__INVITE));
  const canDeleteInvite = computed(() => can(EActions.DELETE, ESubjects.INVITE__INVITE));

  const canReadRecipient = computed(() => can(EActions.READ, ESubjects.INVITE__RECIPIENT));
  const canCreateRecipient = computed(() => can(EActions.CREATE, ESubjects.INVITE__RECIPIENT));
  const canUpdateRecipient = computed(() => can(EActions.UPDATE, ESubjects.INVITE__RECIPIENT));
  const canDeleteRecipient = computed(() => can(EActions.DELETE, ESubjects.INVITE__RECIPIENT));

  const canReadRole = computed(() => can(EActions.READ, ESubjects.INVITE__ROLE));
  const canCreateRole = computed(() => can(EActions.CREATE, ESubjects.INVITE__ROLE));
  const canUpdateRole = computed(() => can(EActions.UPDATE, ESubjects.INVITE__ROLE));
  const canDeleteRole = computed(() => can(EActions.DELETE, ESubjects.INVITE__ROLE));

  const canReadRoleSpecialty = computed(() => can(EActions.READ, ESubjects.INVITE__ROLESPECIALTY));
  const canCreateRoleSpecialty = computed(() =>
    can(EActions.CREATE, ESubjects.INVITE__ROLESPECIALTY)
  );
  const canUpdateRoleSpecialty = computed(() =>
    can(EActions.UPDATE, ESubjects.INVITE__ROLESPECIALTY)
  );
  const canDeleteRoleSpecialty = computed(() =>
    can(EActions.DELETE, ESubjects.INVITE__ROLESPECIALTY)
  );

  const canSendInvite = computed(() => canCreateInvite.value);

  const canViewInviteList = computed(
    () =>
      canReadInvite.value ||
      canReadRecipient.value ||
      can(EActions.READ, ESubjects.REFERRAL__REFERRAL)
  );

  const canLoadPublicRoles = computed(() => canReadRole.value || canSendInvite.value);

  const canLoadPublicRoleSpecialties = computed(
    () => canReadRoleSpecialty.value || canSendInvite.value
  );

  const canAccessInviteRolesSettings = computed(
    () =>
      canReadRole.value ||
      canCreateRole.value ||
      canUpdateRole.value ||
      canDeleteRole.value ||
      canReadRoleSpecialty.value ||
      canCreateRoleSpecialty.value ||
      canUpdateRoleSpecialty.value ||
      canDeleteRoleSpecialty.value
  );

  const canViewRolesSection = computed(() => canReadRole.value || canCreateRole.value);

  const canViewSpecialtiesSection = computed(
    () => canReadRoleSpecialty.value || canCreateRoleSpecialty.value
  );

  return {
    canCreateInvite,
    canReadInvite,
    canUpdateInvite,
    canDeleteInvite,
    canReadRecipient,
    canCreateRecipient,
    canUpdateRecipient,
    canDeleteRecipient,
    canReadRole,
    canCreateRole,
    canUpdateRole,
    canDeleteRole,
    canReadRoleSpecialty,
    canCreateRoleSpecialty,
    canUpdateRoleSpecialty,
    canDeleteRoleSpecialty,
    canSendInvite,
    canViewInviteList,
    canLoadPublicRoles,
    canLoadPublicRoleSpecialties,
    canAccessInviteRolesSettings,
    canViewRolesSection,
    canViewSpecialtiesSection,
  };
};
